import { render, staticRenderFns } from "./mycourse.vue?vue&type=template&id=9022718a&scoped=true&"
import script from "./mycourse.vue?vue&type=script&lang=js&"
export * from "./mycourse.vue?vue&type=script&lang=js&"
import style0 from "./mycourse.vue?vue&type=style&index=0&id=9022718a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9022718a",
  null
  
)

export default component.exports